import { createFileRoute, redirect } from "@tanstack/react-router";

/** Ruta legada: redirige a solicitud de trial (sin copy “gratis”). */
export const Route = createFileRoute("/prueba-gratis")({
  beforeLoad: () => {
    throw redirect({ to: "/solicitar-trial" });
  },
});
